<template>
  <!-- bootstrap-vue 2.23 b-form-radio-group'un slot'lu kullanımı (Aşama 2.3): div[role=radiogroup].bv-no-focus-ring.
       İçteki FormRadio'lar grup adını, seçili değeri ve satır içi (inline) düzeni gruptan alır. -->
  <div :id="safeId" role="radiogroup" tabindex="-1" class="bv-no-focus-ring" :aria-required="required ? 'true' : null">
    <slot />
  </div>
</template>

<script>
  import { looseEqual, nextFormCheckId } from './formCheck';

  export default {
    name: 'FormRadioGroup',
    // v-model: modelValue/update:modelValue; açık `:checked` + `input` de sürer.
    emits: ['update:modelValue', 'input', 'change'],
    provide() {
      return { formRadioGroup: this };
    },
    props: {
      modelValue: { default: undefined },
      checked: { default: null },
      id: { type: String, default: undefined },
      name: { type: String, default: undefined },
      disabled: { type: Boolean, default: false },
      required: { type: Boolean, default: false },
      stacked: { type: Boolean, default: false },
      size: { type: String, default: undefined },
      // bootstrap-vue bu özniteliği yalnız `options` ile üretilen radyolara geçirir; slot'lu kullanımda DOM'a yazılmaz.
      ariaDescribedby: { type: String, default: undefined }
    },
    data() {
      return {
        localId: nextFormCheckId('form-radio-group'),
        localChecked: this.modelValue === undefined ? this.checked : this.modelValue
      };
    },
    computed: {
      safeId() {
        return this.id || this.localId;
      },
      boundChecked() {
        return this.modelValue === undefined ? this.checked : this.modelValue;
      },
      groupName() {
        return this.name || this.safeId;
      },
      inline() {
        return !this.stacked;
      }
    },
    watch: {
      boundChecked(newValue) {
        if (!looseEqual(newValue, this.localChecked)) this.localChecked = newValue;
      },
      localChecked(newValue, oldValue) {
        if (!looseEqual(newValue, oldValue)) {
          this.$emit('update:modelValue', newValue);
          this.$emit('input', newValue);
        }
      }
    }
  };
</script>
